<template>
	<div id="wrapper">
		<SidebarView
			:memacc="true"
			:memaccVisible="true"
			:balanceTransferBulk="true"
		/>
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />

				<div class="container-fluid">
					<div class="row">
						<div class="py-3 d-flex flex-row align-items-center justify-content-between">
							<div class="col-12">
								<div class="card card-shape home-box">
									<div class="card-header d-flex justify-content-between align-items-center">
										<h6 class="m-0 fw-bold text-green">Balance Transfer (Bulk)</h6>
										<div>
											<b-link v-b-modal.monitor class="fw-semibold ms-2 akkurate-green">
												<font-awesome-icon :icon="['fas', 'bars-progress']" />
											</b-link>
										</div>
									</div>
									<div class="card-body">
										<form class="form" @submit.prevent="storeData">
											<div class="row">
												<div class="row mt-2">
													<div class="col">
														<label class="akkurate-dark small" for="account_type">Source Account<star></star></label>
														<b-form-group id="account_type" label-for="account_type">
															<multiselect
																class="mt-2 field-container"
																v-model="form.from"
																:options="account_options"
																label="name"
																track-by="id"
															/>
														</b-form-group>
													</div>

													<div class="col">
														<label class="akkurate-dark small" for="account_type">Destination Account<star></star></label>
														<b-form-group id="account_type" label-for="account_type">
															<multiselect
																class="mt-2 field-container"
																v-model="form.to"
																:options="account_options"
																label="name"
																track-by="id"
															/>
														</b-form-group>
													</div>
												</div>

												<p class="akkurate-danger small">{{ acc_error }}</p>
											</div>
											<hr />
											<div class="text-center py-3">
												<b-button type="submit" :disabled="isSaving" class="akkurate-green-btn text-white btn-size">
													<font-awesome-icon class="me-2" :icon="['fas', 'forward']" />
													Transfer
												</b-button>
												<button type="reset" @click="resetForm" class="btn akkurate-gray-btn text-white btn-size my-2 ms-3">
													<font-awesome-icon class="me-2" :icon="['fas', 'rotate-right']" />
													Reset
												</button>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>

						<!-- Monitor Modal -->
						<b-modal size="lg" id="monitor" @ok="handleOk" @hidden="stopPolling">
							<template #modal-title>
								<h6 class="fw-bold mb-0 akkurate-green">Track Transfer</h6>
							</template>

							<b-alert v-if="(jobStatus || '').toLowerCase() === 'completed'" show variant="success" class="d-flex align-items-center">
								<font-awesome-icon class="me-2" :icon="['fas','check-circle']" />
								<strong class="me-1">Transfer Completed!</strong>
								<span>Processed {{ stats.processed }} of {{ stats.total }} accounts.</span>
							</b-alert>
							<b-alert v-else-if="(jobStatus || '').toLowerCase() === 'failed'" show variant="danger" class="d-flex align-items-center">
								<font-awesome-icon class="me-2" :icon="['fas','triangle-exclamation']" />
								<strong class="me-1">Transfer Failed.</strong>
								<span>Please review the message below.</span>
							</b-alert>

							<div class="mb-3">
								<label class="small akkurate-dark">Process ID</label>
								<div class="d-flex">
									<b-form-input v-model.trim="jobIdInput" placeholder="Enter Job ID to track"></b-form-input>
									<b-button class="ms-2" variant="outline-secondary" @click="copyJobId" :disabled="!jobIdInput">
										<font-awesome-icon :icon="['far','copy']" />
									</b-button>
								</div>
								<small v-if="lastStartedJobId && !jobIdInput" class="text-muted">
									Last started job: {{ lastStartedJobId }}
								</small>
							</div>

							<div class="mb-3">
								<div class="d-flex justify-content-between small">
									<span>Status: <b-badge :variant="statusVariant(jobStatus)">{{ jobStatus || '-' }}</b-badge></span>
									<span>{{ progressPercent }}%</span>
								</div>
								<b-progress :value="progressPercent" :max="100" height="20px">
									<b-progress-bar class="akkurate-green-btn" :value="progressPercent" :label="progressPercent + '%'" />
								</b-progress>
								<div class="mt-2">
									<code class="small akkurate-green">{{ jobMessage || '-' }}</code>
								</div>
							</div>

							<template #modal-footer="{ ok }">
								<div class="w-100">
									<b-button @click="$bvModal.hide('monitor')" type="button" class="akkurate-grey-btn border-0 btn-size ms-2 float-right">
										<span class="small">
											<font-awesome-icon class="me-2" :icon="['fas', 'close']" />Close
										</span>
									</b-button>

									<b-button v-if="!isPolling" @click="ok()" type="submit" :disabled="!jobIdInput" class="akkurate-green-btn btn-size float-right border-0 ms-2">
										<span class="small">
											<font-awesome-icon class="me-2" :icon="['fas', 'search']" />Track
										</span>
									</b-button>

									<b-button v-else @click="stopPolling" type="button" class="btn btn-warning btn-size float-right border-0 ms-2">
										<span class="small">
											<font-awesome-icon class="me-2" :icon="['fas', 'pause']" />Stop
										</span>
									</b-button>
								</div>
							</template>
						</b-modal>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>

		<ChatBot />
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import Multiselect from "vue-multiselect";
import ApiService from "@/core/services/api.service";
import ChatBot from "@/views/components/AI/ChatBot.vue";

/** Bulk product-to-product balance migration job start (not commission management APIs). */
const BULK_BALANCE_TRANSFER_JOB_START = "/transactions/transfer_commission";

export default {
	name: "BalanceTransferBulk",
	components: {
		SidebarView,
		TopbarView,
		Footer,
		Multiselect,
		ChatBot,
	},
	mounted() {
		const token = localStorage.getItem("token");
		if (!token) {
			this.$router.push({ path: "/login" });
		}
		this.getAccountTypes();
		this.requestNotificationPermission();
	},
	data() {
		return {
			...this.initialState(),
			coaSubheadOptions: [],
			errors: [],
			isSaving: false,
			acc_error: "",
			account_options: [],
			form: {
				from: "",
				to: "",
			},
			jobIdInput: "",
			lastStartedJobId: "",
			jobStatus: "",
			jobMessage: "",
			isPolling: false,
			pollTimer: null,
			stats: { total: 0, scanned: 0, processed: 0 },
		};
	},
	computed: {
		progressPercent() {
			if ((this.jobStatus || "").toLowerCase() === "completed") return 100;
			const total = Number(this.stats.total || 0);
			const scanned = Number(this.stats.scanned || 0);
			if (!total) return 0;
			const pct = Math.floor((Math.min(scanned, total) / total) * 100);
			return isNaN(pct) ? 0 : pct;
		},
	},
	methods: {
		async getAccountTypes() {
			this.$Progress.start();
			await ApiService.get("/accounts/create/dropdown")
				.then((response) => {
					this.isLoadingSaving = false;
					this.$Progress.finish();
					this.account_options = response.data.account_types;
				})
				.catch((error) => {
					this.isSaving = false;
					this.$Progress.fail();
					if (error.response && error.response.data && error.response.data.errors) {
						this.form.errors = error.response.data.errors;
					}
				});
		},
		notifyDesktop(title, body) {
			try {
				if (!("Notification" in window)) return;
				if (Notification.permission === "granted") {
					new Notification(title, { body });
				} else if (Notification.permission !== "denied") {
					Notification.requestPermission().then((perm) => {
						if (perm === "granted") new Notification(title, { body });
					});
				}
			} catch (e) {
				// ignore
			}
		},
		requestNotificationPermission() {
			try {
				if (!("Notification" in window)) return;
				if (Notification.permission !== "granted" && Notification.permission !== "denied") {
					Notification.requestPermission();
				}
			} catch (e) {
				// ignore
			}
		},
		async handleOk(bvModalEvent) {
			bvModalEvent.preventDefault();
			this.trackJob();
		},
		storeData() {
			if (!this.form.from || !this.form.to) {
				toast.fire({ icon: "error", title: "Please select both source and destination products" });
				return;
			}
			if (this.form.from?.id === this.form.to?.id) {
				toast.fire({ icon: "error", title: "Source and destination products must be different" });
				return;
			}

			this.isSaving = true;
			this.$Progress.start();

			const form = {
				product_from: String(this.form.from?.id),
				product_to: String(this.form.to?.id),
			};

			ApiService.post(BULK_BALANCE_TRANSFER_JOB_START, form)
				.then((response) => {
					this.isSaving = false;
					this.$Progress.finish();

					const jobId = response.data?.job_id;

					toast.fire({
						icon: "success",
						title: response.data.message || "Transfer started",
					});

					if (jobId) {
						this.lastStartedJobId = jobId;
						this.jobIdInput = jobId;
						this.$bvModal.show("monitor");
						this.startPolling();
					}

					this.resetForm();
				})
				.catch((error) => {
					this.isSaving = false;
					this.$Progress.fail();
					const msg = error.response?.data?.message || "Failed to start transfer";
					toast.fire({ icon: "error", title: msg });
					if (error.response && error.response.data && error.response.data.errors) {
						this.errors = error.response.data.errors;
					}
				});
		},
		resetForm() {
			this.form = this.initialState().form;
			this.entities = [{ amount: "", account_options: { id: "", name: "" } }];
			this.errors = [];
		},
		initialState() {
			return {
				form: {
					from_code: [],
					to_code: [],
					errors: [],
					trans_date: "",
				},
				entities: [{ amount: "", account_options: { id: "", name: "" } }],
			};
		},
		async trackJob() {
			if (!this.jobIdInput) {
				toast.fire({ icon: "error", title: "Please enter a Job ID to track" });
				return;
			}
			this.startPolling();
		},
		startPolling() {
			if (this.isPolling) return;
			this.isPolling = true;
			this.fetchJobStatus();
			this.pollTimer = setInterval(() => {
				this.fetchJobStatus();
			}, 2000);
		},
		stopPolling() {
			this.isPolling = false;
			if (this.pollTimer) {
				clearInterval(this.pollTimer);
				this.pollTimer = null;
			}
		},
		async fetchJobStatus() {
			if (!this.jobIdInput) return;
			await ApiService.get(`/transactions/job-status/${this.jobIdInput}`)
				.then((response) => {
					const data = response.data || {};
					const prevStatus = (this.jobStatus || "").toLowerCase();
					this.jobStatus = data.status || "";
					this.jobMessage = data.message || "";
					if (data.stats && (typeof data.stats.total !== "undefined" || typeof data.stats.scanned !== "undefined")) {
						const total = Number(data.stats.total || 0);
						const scanned = Number(data.stats.scanned || 0);
						const processed = Number(data.stats.processed || 0);
						this.stats = { total, scanned, processed };
					} else {
						this.parseStatsFromMessage(this.jobMessage);
					}
					const newStatus = (this.jobStatus || "").toLowerCase();
					if (["completed", "failed"].includes(newStatus)) {
						this.stopPolling();
					}
					if (newStatus === "completed" && prevStatus !== "completed") {
						this.onJobCompleted();
					}
					if (newStatus === "failed" && prevStatus !== "failed") {
						this.onJobFailed();
					}
				})
				.catch((error) => {
					if (error.response && error.response.status === 404) {
						this.stopPolling();
						toast.fire({ icon: "error", title: "Job not found" });
					}
				});
		},
		onJobCompleted() {
			toast.fire({ icon: "success", title: "Transfer completed successfully" });
			this.playCompletionSound();
			this.notifyDesktop("Transfer Completed", `Processed ${this.stats.processed}/${this.stats.total}`);
		},
		onJobFailed() {
			toast.fire({ icon: "error", title: "Transfer failed" });
			this.notifyDesktop("Transfer Failed", (this.jobMessage || "").toString().slice(0, 100));
		},
		playCompletionSound() {
			try {
				const AudioCtx = window.AudioContext || window.webkitAudioContext;
				if (!AudioCtx) return;
				const ctx = new AudioCtx();
				const o = ctx.createOscillator();
				const g = ctx.createGain();
				o.type = "sine";
				o.frequency.setValueAtTime(880, ctx.currentTime);
				g.gain.setValueAtTime(0.001, ctx.currentTime);
				g.gain.exponentialRampToValueAtTime(0.1, ctx.currentTime + 0.01);
				g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.25);
				o.connect(g);
				g.connect(ctx.destination);
				o.start();
				o.stop(ctx.currentTime + 0.26);
			} catch (e) {
				// no-op
			}
		},
		parseStatsFromMessage(msg) {
			const extract = (key) => {
				const re = new RegExp(`${key}\\s*=\\s*([0-9]+)`, "i");
				const m = (msg || "").match(re);
				return m ? Number(m[1]) : 0;
			};
			const total = extract("total");
			const scanned = extract("scanned");
			const processed = extract("processed");
			this.stats = { total, scanned, processed };
		},
		statusVariant(status) {
			const s = (status || "").toLowerCase();
			if (s === "completed") return "success";
			if (s === "failed") return "danger";
			if (s === "processing") return "warning";
			if (s === "pending") return "info";
			return "secondary";
		},
		copyJobId() {
			if (!this.jobIdInput) return;
			try {
				navigator.clipboard.writeText(this.jobIdInput);
				toast.fire({ icon: "success", title: "Job ID copied" });
			} catch (e) {
				// ignore
			}
		},
	},
	beforeDestroy() {
		this.stopPolling();
	},
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
